export { default, useExitingPersistence } from '../entering/exiting-persistence';
export type { ExitingPersistenceProps } from '../entering/exiting-persistence';
